import client from '../utils/client';
import { settingsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const settingsService = {
  getSettings,
  updateSettings
}

function getSettings() {
  return client.get(settingsUrl + '?page=1&per_page=999')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateSettings(formDate) {
  return client.post(settingsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}